// test617
(617 && 0);
